export const firstLetters = (string) =>
    (string || "")
        .split(" ")
        .slice(0, 2)
        .map((n) => n.substring(0, 1));
